import { Search } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useNavGroups } from '@/app/layout/nav-items'
import { Button } from '@/components/ui/button'
import {
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import { Kbd } from '@/components/ui/kbd'
import { messages } from '@/lib/messages'

/** Ctrl+K (Mac'te ⌘K) ile açılan sayfa/rapor arama paleti; kalemler kenar menüyle aynı. */
export function CommandMenu() {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const groups = useNavGroups()

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key.toLowerCase() === 'k' && (event.ctrlKey || event.metaKey)) {
        event.preventDefault()
        setOpen((value) => !value)
      }
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [])

  return (
    <>
      {/* sm altında yalnız simge: dokunmatik ekranda kısayol ipucu anlamsız, üst çubuk 375px'e sığsın. */}
      <Button
        variant="outline"
        size="sm"
        aria-label={messages.nav.search}
        className="max-sm:size-(--control-height-sm) max-sm:px-0"
        onClick={() => setOpen(true)}
      >
        <Search data-icon="inline-start" />
        <span className="max-sm:hidden">{messages.nav.search}</span>
        <Kbd className="max-sm:hidden">Ctrl K</Kbd>
      </Button>
      <CommandDialog open={open} onOpenChange={setOpen} title={messages.nav.search}>
        <Command>
          <CommandInput placeholder={messages.nav.searchPlaceholder} />
          <CommandList>
            <CommandEmpty>{messages.nav.searchEmpty}</CommandEmpty>
            {groups.map((group) => (
              <CommandGroup key={group.label} heading={group.label}>
                {group.items.map((item) => (
                  <CommandItem
                    key={item.to}
                    value={`${group.label} ${item.label}`}
                    onSelect={() => {
                      setOpen(false)
                      void navigate(item.to)
                    }}
                  >
                    <item.icon />
                    {item.label}
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </CommandDialog>
    </>
  )
}
